import { enumPermissions } from '../../enums';
import dao from '../../common/DataAccessUtil'; //'../../../libs/springutils/dist/utils/DataAccessUtil'
import { IQueryParameter } from '../../common/DataAccessUtil';
import authUtil from '../../common/AuthorizationUtil';
import configurationService from '../core/configuration.service';
import userService from './user.service';
import UtilityService from '../core/UtilityService';
const ControllerName = 'Users';

export default {
  async login(
    username: string,
    password: string,
    captchaText: string,
    dntCaptchaTextValue: string,
    dntCaptchaTokenValue: string,
  ) {
    const body = {
      Username: username,
      Password: password,
      DNTCaptchaText: dntCaptchaTextValue,
      DNTCaptchaToken: dntCaptchaTokenValue,
      DNTCaptchaInputText: captchaText,
    };

    return dao.PostFormData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/login', body);
  },
  loginOtp: async (nationalCode: string, mobileNumber: string, code: string) => {
    const body = { NationalCode: nationalCode, MobileNumber: mobileNumber, Code: code };
    return dao.postJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/loginOtp', body);
  },
  IsAdministrtor: async () => {
    try {
      const response = await dao.getJsonData(
        configurationService.getApiConfigForIdentityServer(),
        ControllerName + '/IsAdministrator',
      );
      return true;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return false;
        }
      }
      return false;
    }
  },
  IsAuthenticated: async () => {
    try {
      await dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/islogin');
      return true;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return false;
        }
      }
      return false;
    }
  },
  SignOut: async () => {
    try {
      await dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName + '/logOut');
      return true;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return false;
        }
      }
      return false;
    }
  },

  GetFullName: async () => {
    try {
      let response = await dao.getJsonData(configurationService.getApiConfigForIdentityServer(), ControllerName);
      if (response != null) {
        let fn = '';
        if (response.firstName) fn += response.firstName;
        if (response.lastName) fn += ' ' + response.lastName;
        return fn;
      }
      return '';
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return '';
        }
      }
      return '';
    }
  },
  GetUserName: async () => {
    try {
      return await authUtil.getUserName(configurationService.getAllConfig().storageType);
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return '';
        }
      }
      return '';
    }
  },
  ManageRole: async () => {
    try {
      const response = await dao.getJsonData(
        configurationService.getApiConfigForIdentityServer(),
        ControllerName + '/ManageRole',
      );
      return true;
    } catch (ex) {
      const err = ex as any;
      if (err.response) {
        if (err.response.status === 403) {
          return false;
        }
      }
      return false;
    }
  },
  HasPermission: async (permissionByKey: enumPermissions) => {
    return userService.HasPermission(permissionByKey);
  },
};
